import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

export const useFetch = (url, filters = {}, mandatories, action) => {

    const dispatch = useDispatch()

    const [state, setState] = useState({
        items : [],
        loading : true
    })

    useEffect(() => {
        dispatch({ type: action, payload: state.items})
    }, [state.items])

    useEffect(() => {
        if(mandatories && mandatories.length && mandatories.some(m => !filters[m])){
            setState(s => ({
                items : [],
                loading : false
            }))
        }else
        (async function () {
            const {data} = await url(filters)
            const responseData = data

            if(responseData){
                setState({
                    items: responseData,
                    loading : false
                })
            } else {
                setState(s => ({
                    ...s,
                    loading : false
                }))
            }
        })()

    }, [filters, url])

    const resetItems = () => {
            setState({
            items : [],
            loading : true
        })
    }

    return [state.items, state.loading, resetItems]
}